import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const handleScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" style={{
    backgroundImage: `linear-gradient(to bottom, rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.6)), url('https://cdn.magicpatterns.com/uploads/vYnAEVUpKmsGqAaW2FpZKr/Frankfurt-IT_260204.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-97">
        <div className="max-w-3xl" data-id="element-98">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6" data-id="element-99">
            Projektmanagement
          </h1>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6" data-id="element-100">
            Excellence für Ihr Unternehmen
          </h1>
          <p className="text-xl text-blue-100 mb-10 leading-relaxed max-w-2xl" data-id="element-101">
            Professionelle Beratung, Schulungen und Freelance-Services
            maßgeschneidert für Mittelstand bis Großunternehmen und Banken.
          </p>
          <p className="text-xl text-blue-100 mb-10 leading-relaxed max-w-2xl" data-id="element-102">
            Wir bringen Struktur und Erfolg in Ihre komplexesten Vorhaben.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-103">
            <a href="#contact" onClick={e => handleScrollToSection(e, 'contact')} className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-blue-900 bg-white hover:bg-slate-50 transition-colors duration-200" data-id="element-104">
              Jetzt Beratung anfragen
            </a>
            <a href="#services" onClick={e => handleScrollToSection(e, 'services')} className="inline-flex items-center justify-center px-8 py-4 border border-blue-400 text-base font-medium rounded-md text-white hover:bg-blue-800 transition-colors duration-200" data-id="element-105">
              Unsere Leistungen
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-106" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}